/**
 * CourseFormFooter — shows / hides the "more options" panel in course footers.
 *
 * Replaces T.Module.CourseFormFooter (c-course-form-footer.js).
 */
export class CourseFormFooter {
  private ctx: HTMLElement;
  private abortController: AbortController;

  constructor(el: HTMLElement) {
    this.ctx = el;
    this.abortController = new AbortController();
  }

  init(): this {
    const { signal } = this.abortController;
    const moreOptions = this.ctx.querySelector<HTMLElement>('.more-options');
    const optionsBtn = this.ctx.querySelector<HTMLElement>('.options');

    optionsBtn?.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        optionsBtn.querySelector<HTMLElement>('.show-options')?.classList.toggle('hide');
        optionsBtn.querySelector<HTMLElement>('.hide-options')?.classList.toggle('hide');
        moreOptions?.classList.toggle('hide');
      },
      { signal },
    );
    return this;
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="course-form-footer"]')
      .forEach((el) => new CourseFormFooter(el).init());
  }
}
